<template>
  <div>
    <a-card>
      <a-form-model
        ref="ruleForm"
        :model="currentItem"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        style="max-width: 600px; margin: 50px auto"
      >
        <a-form-model-item label="名称" prop="material.title">
          <a-input
            v-model="currentItem.material.title"
            placeholder="请输入名称"
          />
        </a-form-model-item>
        <a-form-model-item label="关联离校批次" prop="material.batchId">
          <a-select
            v-model="currentItem.material.batchId"
            placeholder="请选择关联离校批次"
          >
            <a-select-option v-for="item in graduationBatchList" :key="item.id" :value="item.id">{{item.name}}</a-select-option>
          </a-select>
        </a-form-model-item>
        <ul class="dynamic-list">
          <li
            v-for="(item, index) in currentItem.materialDetails"
            :key="index"
          >
            <div v-if="item.type == 0">
              <div class="label">
                <div>
                  <label for="">单选</label>
                  <span class="padding">是否必填</span>
                  <a-checkbox v-model="item.required"></a-checkbox>
                </div>
                <div>
                  <a-popconfirm
                    title="确认删除吗?"
                    ok-text="是"
                    cancel-text="否"
                    @confirm="delItem(index)"
                  >
                    <a-icon type="close" class="hover" />
                  </a-popconfirm>
                </div>
              </div>

              <a-form-item label="名称">
                <a-input v-model="item.name" placeholder="请输入名称" />
              </a-form-item>
              <a-form-item
                v-for="(sub, subIndex) in item.perms"
                :key="subIndex"
                :label="'选项' + (subIndex + 1)"
              >
                <a-input
                  v-model="sub.name"
                  placeholder="请输入名称"
                  style="width: 90%; margin-right: 10px"
                />
                <a-popconfirm
                  title="确认删除吗?"
                  ok-text="是"
                  cancel-text="否"
                  @confirm="delSubItem(index, subIndex)"
                >
                  <a-icon type="close" class="hover" />
                </a-popconfirm>
              </a-form-item>
              <div style="padding: 0 20px 20px">
                <a-button block icon="plus" @click="addSubItem(index)"
                  >添加选项</a-button
                >
              </div>
            </div>
            <div v-else>
              <div class="label">
                <div>
                  <label for="">文本</label>
                  <span class="padding">是否必填</span>
                  <a-checkbox v-model="item.required"></a-checkbox>
                </div>
                <div>
                  <a-popconfirm
                    title="确认删除吗?"
                    ok-text="是"
                    cancel-text="否"
                    @confirm="delItem(index)"
                  >
                    <a-icon type="close" class="hover" />
                  </a-popconfirm>
                </div>
              </div>

              <a-form-item label="名称">
                <a-input v-model="item.name" placeholder="请输入名称" />
              </a-form-item>
            </div>
          </li>
        </ul>
      </a-form-model>
    </a-card>
    <footer-tool-bar :isCenter="true">
      <div class="btn-group" style="margin: 0">
        <a-button @click="addInputItem" :loading="loading">添加输入框</a-button>
        <a-button @click="addRadioItem" :loading="loading">添加单选框</a-button>
        <a-button type="primary" @click="submit" :loading="loading"
          >保存</a-button
        >
      </div>
    </footer-tool-bar>
  </div>
</template>
<script>
import * as service from '@/services/material';
import {listGraduationBatch} from '@/services/graduationList';
import FooterToolBar from "@/components/tool/FooterToolBar";
const rules = {
  "material.title": [
    { required: true, message: "请输入名称", trigger: "change" },
  ],
  "material.batchId": [
    { required: true, message: "请选择离校批次", trigger: "change" },
  ],
};
export default {
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
      },
      currentItem: {
        material: {
          title: undefined,
          batchId: undefined,
        },
        materialDetails: [
          // {
          //   name: "单选",
          //   type: "0",
          //   isNull: "0",
          //   perms: [{ name: "选项名称1" }, { name: "选项名称2" }],
          // },
          // {
          //   name: "文本1",
          //   type: "1",
          //   isNull: "0",
          // },
          // {
          //   name: "文本2",
          //   type: "1",
          //   isNull: "0",
          // },
        ],
      },
      rules,
      loading: false,
      graduationBatchList: [],
    };
  },
  components: {
    FooterToolBar,
  },
  methods: {
    delItem(index) {
      this.currentItem.materialDetails.splice(index, 1);
    },
    delSubItem(index, subIndex) {
      this.currentItem.materialDetails[index].perms.splice(subIndex, 1);
    },
    addSubItem(index) {
      this.currentItem.materialDetails[index].perms.push({
        name:
          "选项名称" +
          (this.currentItem.materialDetails[index].perms.length + 1),
      });
    },
    addRadioItem() {
      this.currentItem.materialDetails.push({
        name: "单选",
        type: "0",
       required: true,
        perms: [{ name: "选项名称1" }, { name: "选项名称2" }],
      });
    },
    addInputItem() {
      this.currentItem.materialDetails.push({
        name: "文本",
        type: "1",
        required: true,
      });
    },
    submit() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          let item = this.currentItem;
          item.materialDetails.forEach(o=>o.isNull=o.required?'0':'1')
          // this.loading = true;
          if (item.material.id) {
            await service.update(item);
          } else {
            await service.save(item);
          }
          this.$message.success("操作成功");
          this.loading = false;
          this.$router.back();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    initData(){
      this.$route.query.id &&
        service.getOne({id:this.$route.query.id}).then((res) => {
           res.materialDetails.forEach(o=>{
            o.required= o.isNull=='0'
             if(o.perms){
               o.perms=JSON.parse(o.perms)
             }
           })
          this.currentItem = res
        });
    }
  },
  mounted(){
    this.initData();
    listGraduationBatch().then(res => {
      this.graduationBatchList = res;
    });
  }
};
</script>
<style lang="less" scoped>
.dynamic-list {
  margin-top: 20px;
  list-style: none;

  li {
    background: #ffff;
    margin-bottom: 20px;
    border: 1px solid #eee;
    border-radius: 5px;

    .padding {
      padding-left: 30px;
      padding-right: 10px;
      font-weight: normal;
    }

    .hover:hover {
      cursor: pointer;
      color: @primary-color;
    }

    .label {
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      color: #000;
      margin-bottom: 10px;
      padding: 15px;
      display: flex;
      justify-content: space-between;
      background: #fff;
      border-bottom: 1px solid #eee;
      font-weight: bold;
    }
  }
}
</style>